import React from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

export default function HeroSection() {
  const navigate = useNavigate();

  const scrollToWaitlist = () => {
    const el = document.getElementById('waitlist');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      // Move focus to the first input for keyboard users
      const firstInput = el.querySelector('input');
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 600);
      }
    }
  };

  return (
    <Box
      component="section"
      aria-label="Introduction"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        pt: { xs: 10, sm: 12 },
        pb: { xs: 8, sm: 10 },
        background: (theme) =>
          theme.palette.mode === 'dark'
            ? `radial-gradient(ellipse 80% 60% at 50% -20%, rgba(91, 141, 239, 0.15), transparent)`
            : `radial-gradient(ellipse 80% 60% at 50% -20%, rgba(58, 108, 212, 0.10), transparent)`,
      }}
    >
      <Container maxWidth="md">
        <Stack spacing={4} alignItems="center" textAlign="center">
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: '2.25rem', sm: '3rem', md: '3.75rem' },
              fontWeight: 700,
              lineHeight: 1.1,
              color: 'text.primary',
            }}
          >
            Born from a simple idea:{' '}
            <Box
              component="span"
              sx={{
                background: (theme) =>
                  `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              The syllabus is the source of truth.
            </Box>
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: { xs: '1.05rem', sm: '1.2rem' },
              color: 'text.secondary',
              maxWidth: 600,
              lineHeight: 1.7,
            }}
          >
            Syllabex makes intelligent use of AI, automating the boilerplate
            work involved in course creation and management. Handling modules,
            setting due dates, updating a course from one semester to another?
            We strive to provide an LMS solution that gives instructors
            more time to focus on instruction, learning designers more time to focus on design,
            and in turn, give students a better learning experience.
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            sx={{ justifyContent: 'center' }}
          >
            <Button
              variant="contained"
              size="large"
              onClick={scrollToWaitlist}
              endIcon={<ArrowDownwardIcon />}
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '1rem',
              }}
            >
              Join the Waitlist
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => navigate('/product')}
              sx={{
                px: 4,
                py: 1.5,
                fontSize: '1rem',
              }}
            >
              Learn More
            </Button>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
}
